/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { MedicalServiceGroupDto } from './medical-service-group-dto';
import { UserAccountDto } from './user-account-dto';

/**
 * 
 * @export
 * @interface DoctorBasicDto
 */
export interface DoctorBasicDto {
    /**
     * 
     * @type {string}
     * @memberof DoctorBasicDto
     */
    'academicTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof DoctorBasicDto
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorBasicDto
     */
    'inactive'?: boolean;
    /**
     * 
     * @type {MedicalServiceGroupDto}
     * @memberof DoctorBasicDto
     */
    'medicalServiceGroup'?: MedicalServiceGroupDto;
    /**
     * 
     * @type {string}
     * @memberof DoctorBasicDto
     */
    'type'?: DoctorBasicDtoTypeEnum;
    /**
     * 
     * @type {UserAccountDto}
     * @memberof DoctorBasicDto
     */
    'userAccount'?: UserAccountDto;
}

/**
    * @export
    * @enum {string}
    */
export enum DoctorBasicDtoTypeEnum {
    Resident = 'RESIDENT',
    Specialist = 'SPECIALIST',
    Expert = 'EXPERT',
    Consultant = 'CONSULTANT',
    Assistant = 'ASSISTANT',
    InternationalConsultant = 'INTERNATIONAL_CONSULTANT',
    PartnerConsultant = 'PARTNER_CONSULTANT'
}


